(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('relationship-type', {
            parent: 'entity',
            url: '/relationship-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.relationshipType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship-type/relationship-types.html',
                    controller: 'RelationshipTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationshipType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relationship-type-detail', {
            parent: 'entity',
            url: '/relationship-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.relationshipType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relationship-type/relationship-type-detail.html',
                    controller: 'RelationshipTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relationshipType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RelationshipType', function($stateParams, RelationshipType) {
                    return RelationshipType.get({id : $stateParams.id});
                }]
            }
        })
        .state('relationship-type.new', {
            parent: 'relationship-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-dialog.html',
                    controller: 'RelationshipTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('relationship-type');
                });
            }]
        })
        .state('relationship-type.edit', {
            parent: 'relationship-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-dialog.html',
                    controller: 'RelationshipTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RelationshipType', function(RelationshipType) {
                            return RelationshipType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relationship-type.delete', {
            parent: 'relationship-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relationship-type/relationship-type-delete-dialog.html',
                    controller: 'RelationshipTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RelationshipType', function(RelationshipType) {
                            return RelationshipType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('relationship-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
